// JsFromRoutes CacheKey 3c29b3d5c9c11f8965280d64b2974def
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  submitUnitApplication: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/submit_unit_application'),
  freezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/freeze_unit_account'),
  unfreezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/unfreeze_unit_account'),
  freezeUnitCards: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/freeze_unit_cards'),
  unfreezeUnitCards: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/unfreeze_unit_cards'),
  toggleSupportMode: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/toggle_support'),
  updateConfigurableOptions: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/update_configurable_options'),
  deletePlaidAccount: /* #__PURE__ */ definePathHelper('delete', '/admin/members/:id/delete_plaid_account'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/members'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:id'),
}
